import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { LocalizedNumberInput, type LocalizedNumberInputProps } from "@/components/ui/localized-number-input";
import type { ReactNode } from "react";
import { Control, FieldValues, Path } from "react-hook-form";

export interface ConfirmedValueFieldProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  label: string;
  labelAccessory?: ReactNode;
  inputProps?: Omit<LocalizedNumberInputProps, "name" | "onBlur" | "onValueChange" | "value">;
  onChangeValue: (value: string) => void;
}

export function ConfirmedValueField<T extends FieldValues>({
  control,
  name,
  label,
  labelAccessory,
  inputProps,
  onChangeValue,
}: ConfirmedValueFieldProps<T>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <div className="flex items-center gap-1.5">
            <FormLabel>{label}</FormLabel>
            {labelAccessory}
          </div>
          <FormControl>
            <LocalizedNumberInput
              {...inputProps}
              name={field.name}
              ref={field.ref}
              value={field.value ?? ""}
              onBlur={field.onBlur}
              onValueChange={(value) => {
                field.onChange(value);
                onChangeValue(value);
              }}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
